export default __webpack_public_path__ + "a31c4dd608463b3ac9ce20f70b215bed.svg";